var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:['dg-image', { 'is-rounded': _vm.isRounded }, { 'is-bordered': _vm.isBordered }, { 'object-fit': _vm.cover }],on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.url,"alt":"alt","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }